<a
  *ngFor="let follow of followedUsers"
  class="small-picture {{ getColor(follow.followed) }}-bg"
  [routerLink]="['/channel', follow.followed.id]"
  routerLinkActive="active"
>
  <app-profile-picture [user]="follow.followed"></app-profile-picture>
  <span>{{ follow.followed | user }}</span>
</a>
